import {
  Configure,
  InstantSearch,
  useInstantSearch,
} from 'react-instantsearch-hooks-web';
import {
  ALGOLIA_INDEX_NAME,
  searchClientLite,
} from '@/lib/algolia/searchClient';

import Debug from '@/components/debug';
import dynamic from 'next/dynamic';
import { Hit } from 'instantsearch.js';
import { createInstantSearchRouterNext } from '@/lib/algolia/instantSearchRouterNext';
import singletonRouter from 'next/router';
import ProductGridItem from '@/components/product/GridItem';
import { FagmoblerAlgoliaProduct } from '@fagmobler/types';
import { createInfiniteHitsSessionStorageCache } from 'react-instantsearch-dom';
import { SearchProps } from '@/lib/algolia/createCategorySearchProps';
import { VirtualRefinement } from '../productCategory/components/Virtual';
import ProductListInstantSearch from '../productCategory/components/ProductListInstantSearch';
import ProductCategoryListHeader from '../productCategory/components/ProductCategoryListHeader';

const InsightsMiddleware = dynamic(
  () =>
    import('@/lib/algolia/insightsMiddleware').then(
      (mod) => mod.InsightsMiddleware
    ),
  { ssr: false }
);

// Attributes to exclude in "CurrentRefinements" and "ClearRefinements"
export const excludedRefinementAttributes = [
  'tags',
  'query',
  'categories.lvl0',
  'categories.lvl1',
  'categories.lvl2',
  'categorySlugs.lvl0',
  'categorySlugs.lvl1',
  'categorySlugs.lvl2',
];

const sessionStorageCache = createInfiniteHitsSessionStorageCache();

export const SerieSearch = ({
  searchServerState,
  serverUrl,
  facetFilters,
  placeholder,
}: SearchProps) => {
  return (
    <InstantSearch
      searchClient={searchClientLite}
      indexName={ALGOLIA_INDEX_NAME}
      routing={{
        router: createInstantSearchRouterNext({
          singletonRouter,
          serverUrl: serverUrl || undefined,
        }),
      }}
    >
      <InsightsMiddleware />

      <Configure
        hitsPerPage={4 * 8}
        facetFilters={facetFilters || undefined}
        clickAnalytics
        restrictHighlightAndSnippetArrays
        attributesToHighlight={[]}
        facetingAfterDistinct={true}
        attributesToRetrieve={[
          'objectID',
          'posterName',
          'posterDescription',
          'supplier',
          'parentId',
          'price',
          'campaignPrice',
          'sortprice',
          'image',
          'surfaceTreat',
          'serie',
          'concept',
          'length',
          'width',
          'depth',
          'depth2',
          'height',
          'diameter',
          'space',
          'bedsize',
          'material',
          'colour',
          'clothing',
          'model',
          'colour_variants',
          'tags',
          'stock',
          'categories',
          'categorySlugs',
          'articleGroups',
          'articleGroupSlugs',
          'stockUpdated',
          'updated',
          'historicPath',
        ]}
      />
      {/* <VirtualRefinement /> */}
      <ProductCategoryListHeader placeholder={placeholder || undefined} />
      <ProductListInstantSearch cache={sessionStorageCache} />
      <Debug
        data={searchServerState || { searchServerState: null }}
        label="Searchserverstate"
      />
    </InstantSearch>
  );
};
